import { useEffect, useState } from 'react';
import { useStores } from 'Hooks/useStore';
import { Status } from 'app-types';
import useDebouncedValue from 'LearningManager/reports/hooks/useDebouncedValue';
import {
	SEARCH_DEBOUNCE_MS,
	toServerSearch
} from 'LearningManager/helpers/search';

export const usePagedProperties = (
	tenantId: number | undefined,
	enabled = true
) => {
	const { assignUsersStore } = useStores();
	const { pagedProperties } = assignUsersStore;
	const [search, setSearch] = useState('');
	const serverSearch = toServerSearch(search);
	const debouncedSearch = useDebouncedValue(serverSearch, SEARCH_DEBOUNCE_MS);

	useEffect(() => {
		if (!enabled) return;
		if (
			pagedProperties.tenantId !== tenantId ||
			pagedProperties.search !== debouncedSearch ||
			pagedProperties.status === Status.Idle ||
			pagedProperties.status === Status.Failure
		) {
			pagedProperties
				.load(tenantId, debouncedSearch)
				.catch(() => undefined);
		}
	}, [enabled, tenantId, debouncedSearch]);

	const isSearchPending = serverSearch !== debouncedSearch;

	const dropdownProps = {
		options: pagedProperties.items.map((property) => ({
			id: property.id,
			label: property.name
		})),
		loading: pagedProperties.status === Status.Pending || isSearchPending,
		hasMore:
			pagedProperties.hasMore &&
			pagedProperties.loadMoreStatus !== Status.Failure,
		selectAllMode: true,
		onSearch: setSearch,
		onLoadMore: () => pagedProperties.loadMore().catch(() => undefined)
	};

	return {
		pagedProperties,
		search,
		setSearch,
		isSearchPending,
		dropdownProps
	};
};

export default usePagedProperties;
